import Sample1 from "../assets/images/Sample/20200322-201713-deblasio032220.jpg";
import Sample2 from "../assets/images/Sample/7eleven.png";
import Sample3 from "../assets/images/Sample/Westside Rentals.jpg";
import Sample4 from "../assets/images/Sample/Bernie-Sanders-Short-Code-82623-Example-1-300x150.jpg";
import Sample5 from "../assets/images/Sample/Bernie-Sanders-Short-Code-82623-Example-11-300x150.jpg";
import Sample6 from "../assets/images/Sample/Bernie-Sanders-Short-Code-82623-Example-5-300x300.jpg";
import Sample7 from "../assets/images/Sample/Coca-Cola-SMS-Short-Code-30364-13-300x262.jpg";
import Sample8 from "../assets/images/Sample/Entertainment - AMC Theatre.png";
import Sample9 from "../assets/images/Sample/Entertainment - Bijou Theatre.png";
import Sample10 from "../assets/images/Sample/Entertainment - Disney.png";
import Sample11 from "../assets/images/Sample/Entertainment - Landmark Theatre.png";
import Sample12 from "../assets/images/Sample/Entertainment - Meadowlands Racetrack.jpg";
import Sample13 from "../assets/images/Sample/Entertainment - Top Golf.png";
import Sample14 from "../assets/images/Sample/Entertainment - Universal Pictures.png";
import Sample15 from "../assets/images/Sample/Entertainment - Wisconsin State Fair.png";
import Sample16 from "../assets/images/Sample/Hotel & Gaming - Oklahoma Lottery.jpg";
import Sample17 from "../assets/images/Sample/Nonprofit - 211 Los Angeles County.png";
import Sample18 from "../assets/images/Sample/Nonprofit - AARP.jpg";
import Sample19 from "../assets/images/Sample/Nonprofit - American Red Cross.jpg";
import Sample20 from "../assets/images/Sample/Nonprofit - Global Citizen.jpg";
import Sample21 from "../assets/images/Sample/Nonprofit - PETA.jpg";
import Sample22 from "../assets/images/Sample/Nonprofit - The Humane Society of the United States.png";
import Sample23 from "../assets/images/Sample/Nonprofit - World Vision.jpg";
import Sample24 from "../assets/images/Sample/Retail.gif";
import Sample25 from "../assets/images/Sample/Z Banking and Finance - Green Dot.jpg";
import Sample26 from "../assets/images/Sample/biden.jpg";
import Sample27 from "../assets/images/Sample/boa.jpg";
import Sample28 from "../assets/images/Sample/mini-Baskin-Robbins-Short-Code-31310-Example-5-300x300.jpg";
import Sample29 from "../assets/images/Sample/mini-Chipotle-Short-Code-888222-Example-1-300x255.jpg";
import Sample30 from "../assets/images/Sample/mini-IMG_7631.jpg";
import Sample31 from "../assets/images/Sample/mini-IMG_7632.jpg";
import Sample32 from "../assets/images/Sample/mini-IMG_8066.jpg";
import Sample33 from "../assets/images/Sample/mini-IMG_8098.jpg";
import Sample34 from "../assets/images/Sample/mini-IMG_8113.jpg";
import Sample35 from "../assets/images/Sample/mini-IMG_8134.jpg";
import Sample36 from "../assets/images/Sample/mini-IMG_8358.jpg";
import Sample37 from "../assets/images/Sample/mini-IMG_8368.jpg";
import Sample38 from "../assets/images/Sample/mini-IMG_8428.jpg";
import Sample39 from "../assets/images/Sample/mini-IMG_8435.jpg";
import Sample40 from "../assets/images/Sample/mini-IMG_8456.jpg";
import Sample41 from "../assets/images/Sample/mini-IMG_8741.jpg";
import Sample42 from "../assets/images/Sample/mini-IMG_8760 - Copy.jpg";
import Sample43 from "../assets/images/Sample/mini-IMG_8796.jpeg";
import Sample44 from "../assets/images/Sample/mini-IMG_8805.jpeg";
import Sample45 from "../assets/images/Sample/mini-IMG_8806.jpg";
import Sample46 from "../assets/images/Sample/mini-Papa-Murphys-Short-Code-90421-Example-6-300x249.jpg";
import Sample47 from "../assets/images/Sample/mini-Papa-Murphys-Short-Code-90421-Example-8-300x300.jpg";
import Sample48 from "../assets/images/Sample/mini-Pizza-Hut-Short-Code-69488-Example-1.jpg";
import Sample49 from "../assets/images/Sample/mini-Target-Short-Code-827438-Example-1.jpg";
import Sample50 from "../assets/images/Sample/mini-Target-Short-Code-827438-Example-3.jpg";
import Sample51 from "../assets/images/Sample/nugenix.jpg";
import Sample52 from "../assets/images/Sample/trump1.jpg";
import Banking1 from "../assets/images/Banking/Z Banking and Finance - Green Dot.jpg";
import Banking2 from "../assets/images/Banking/boa (1).jpg";
import Banking3 from "../assets/images/Banking/mini-IMG_8435.jpg";
import Banking4 from "../assets/images/Banking/mini-IMG_8456.jpg";
import Stores1 from "../assets/images/Cstores/7eleven.png";
import Politics1 from "../assets/images/Politics/20200322-201713-deblasio032220.jpg";
import Politics2 from "../assets/images/Politics/Bernie-Sanders-Short-Code-82623-Example-1-300x150.jpg";
import Politics3 from "../assets/images/Politics/Bernie-Sanders-Short-Code-82623-Example-11-300x150.jpg";
import Politics4 from "../assets/images/Politics/Bernie-Sanders-Short-Code-82623-Example-5-300x300.jpg";
import Politics5 from "../assets/images/Politics/biden.jpg";
import Politics6 from "../assets/images/Politics/mini-IMG_8760 - Copy.jpg";
import Politics7 from "../assets/images/Politics/trump1.jpg";
import Profit1 from "../assets/images/Profit/Nonprofit - 211 Los Angeles County.png";
import Profit2 from "../assets/images/Profit/Nonprofit - AARP.jpg";
import Profit3 from "../assets/images/Profit/Nonprofit - American Red Cross.jpg";
import Profit4 from "../assets/images/Profit/Nonprofit - Global Citizen.jpg";
import Profit5 from "../assets/images/Profit/Nonprofit - PETA (1).jpg";
import Profit6 from "../assets/images/Profit/Nonprofit - The Humane Society of the United States.png";
import Profit7 from "../assets/images/Profit/Nonprofit - World Vision.jpg";
import Profit8 from "../assets/images/Profit/mini-IMG_8066.jpg";
import Retail1 from "../assets/images/Retail/Retail.gif";
import Retail2 from "../assets/images/Retail/mini-Baskin-Robbins-Short-Code-31310-Example-5-300x300.jpg";
import Retail3 from "../assets/images/Retail/mini-Chipotle-Short-Code-888222-Example-1-300x255.jpg";
import Retail4 from "../assets/images/Retail/mini-IMG_8134.jpg";
import Retail5 from "../assets/images/Retail/mini-IMG_8368.jpg";
import Retail6 from "../assets/images/Retail/mini-IMG_8805.jpeg";
import Sports1 from "../assets/images/Sports/Entertainment - AMC Theatre.png";
import Sports2 from "../assets/images/Sports/Entertainment - Bijou Theatre.png";
import Sports3 from "../assets/images/Sports/Entertainment - Disney.png";
import Sports4 from "../assets/images/Sports/Entertainment - Landmark Theatre.png";
import Sports5 from "../assets/images/Sports/Entertainment - Meadowlands Racetrack.jpg";
import Sports6 from "../assets/images/Sports/Entertainment - Top Golf.png";
import Sports7 from "../assets/images/Sports/Entertainment - Universal Pictures.png";
import Sports8 from "../assets/images/Sports/Entertainment - Wisconsin State Fair.png";
import Sports9 from "../assets/images/Sports/mini-IMG_8098 (1).jpg";
import Sports10 from "../assets/images/Sports/mini-IMG_8098.jpg";
import Sports11 from "../assets/images/Sports/mini-IMG_8428.jpg";
import Sports12 from "../assets/images/Sports/mini-IMG_8806.jpg";
import Hotel1 from "../assets/images/Hotel/Hotel & Gaming - Oklahoma Lottery.jpg";
import Hotel2 from "../assets/images/Hotel/mini-IMG_8796.jpeg";
import Hotel3 from "../assets/images/Hotel/Hotel and Gaming - Parx Casino.png";
import Hotel4 from "../assets/images/Hotel/Hotel and Gaming - Red Hawk Casino.jpg";
import Tech1 from "../assets/images/Tech/mini-IMG_8358.jpg";
import Tech2 from "../assets/images/Tech/Technology - Nixle.jpg";

export const SampleImages = [
  Sample2,
  Sample1,
  Sample3,
  Sample4,
  Sample5,
  Sample6,
  Sample7,
  Sample8,
  Sample9,
  Sample10,
  Sample11,
  Sample12,
  Sample13,
  Sample14,
  Sample15,
  Sample16,
  Sample17,
  Sample18,
  Sample19,
  Sample20,
  Sample21,
  Sample22,
  Sample23,
  Sample24,
  Sample25,
  Sample26,
  Sample27,
  Sample28,
  Sample29,
  Sample30,
  Sample31,
  Sample32,
  Sample33,
  Sample34,
  Sample35,
  Sample36,
  Sample37,
  Sample38,
  Sample39,
  Sample40,
  Sample41,
  Sample42,
  Sample43,
  Sample44,
  Sample45,
  Sample46,
  Sample47,
  Sample48,
  Sample49,
  Sample50,
  Sample51,
  Sample52,
];

export const Banking = [Banking1, Banking2, Banking3, Banking4];

export const Cstores = [Stores1];

export const Hotel = [Hotel1, Hotel2, Hotel3, Hotel4];

export const Tech = [Tech1, Tech2];

export const Politics = [
  Politics1,
  Politics2,
  Politics3,
  Politics4,
  Politics5,
  Politics6,
  Politics7,
];

export const Profit = [
  Profit1,
  Profit2,
  Profit3,
  Profit4,
  Profit5,
  Profit6,
  Profit7,
  Profit8,
];

export const Retail = [Retail1, Retail2, Retail3, Retail4, Retail5, Retail6];

export const Sports = [
  Sports1,
  Sports2,
  Sports3,
  Sports4,
  Sports5,
  Sports6,
  Sports7,
  Sports8,
  Sports9,
  Sports10,
  Sports11,
  Sports12,
];
